export default {
  name: "offset",
  in: "query",
  required: false,
  description:
    "Shifting the view from the beginning of the collection- 0 indicates a listing from the first element.",
  schema: {
    type: "integer",
    example: 1
  }
};
